module.exports = __webpack_public_path__ + "img/atari1200_page7.3eea61c5.jpg";